import {
  mapState,
} from 'vuex';

// @vue/component
export default {
  computed: {
    ...mapState({
      contactSupportLink: state => state.config.contactSupportLink,
    }),
    isUrlValid() {
      const {
        client_uuid: clientUuid,
        location_uuid: locationUuid,
      } = this.$route.query;
      return !!(clientUuid && locationUuid);
    },
  },
  methods: {
    contactSupport() {
      window.open(this.contactSupportLink, '_blank');
    },
  },
};
